export default (model, fields) => {
  const node = {
    id: model.nextNodeId++,
    ...fields,
  };
  model.nodes.push(node);
  return node;
};
